// extracted by mini-css-extract-plugin
export default {"container":"FormAddingModelConfig_container__U+exy","containerOpacity":"FormAddingModelConfig_containerOpacity__hRvXr"};